import {
  REFRESH_FAVICON,
  SET_FAVICON,
  ADD_FAVICON,
  UPDATE_FAVICON,
  GET_FAVICON,
  UPDATE_LOCKED,
} from "./types";
const initialState = {
  initialize: true,
  refresh: false,
  isRequesting: false,
  loadMore: true,
  favicons: [],
  logged:{},
  homePage:{},
  limit: 10,
  page: 1,
  pages: [],
  initializeOption: true,
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case REFRESH_FAVICON:
      return {
        ...state,
        limit: 10,
        page: 1,
        initialize: true,
        refresh: true,
        isRequesting: false,
        loadMore: true,
        favicons: [],
        logged:{},
        homePage:{},
        initializeOption: true,
      };

    case GET_FAVICON:
      return {
        ...state,
        refresh: false,
        isRequesting: true,
      };

    case SET_FAVICON:  
      const tempPages = [];

      if(payload.lastPage > 0 && state.lastPage != payload.lastPage) {
        for(let i = 1; i <= payload.lastPage; i++) {
          tempPages.push(i);
        }
      }
      return {
        ...state,
        isRequesting: false,
        initialize: false,
        page: payload.page,
        loadMore: payload.loadMore, 
        favicons: payload.favicons,
        lastPage: payload.lastPage,
        pages: tempPages.length > 0 ? tempPages : state.pages
      };
    
    case ADD_FAVICON:   
        return {
        ...state,
        isRequesting: false,
        initialize: false,
        upComing: payload,
        };

    case UPDATE_FAVICON:
        return {
        ...state,
        isRequesting: false,
        initialize: false,
        favicons: payload.favicons,
    };
    case UPDATE_LOCKED:
      return {
        ...state,
        isRequesting: false,
        initialize: false,
        favicons: payload.favicons,
      };

    default:
      return state;
  }
};

export default reducer;
